<template>
  <router-link :to="{ name: 'Contact'}"><img class="float_image" src="@/assets/image/common/contact.png"></router-link>
</template>

<script>
  export default {
    name: "ContactButton"
  }
</script>

<style scoped>
  .float_image {
    right: 2rem;
    bottom: 2rem;
    width: 12rem;
    height: 12rem;
    z-index: 99;
  }

  @media screen and (max-width: 767px) {
    .float_image {
      width: 6rem;
      height: 6rem;
    }
  }
</style>